export default {
  hi_IN: {
    home: {
      'Do you own a space / gallary?': 'क्या आप किसी स्थान/गैलरी के मालिक हैं?',
      'Click here to signup': 'साइन अप करने के लिए यहां क्लिक करें',
      'About Us': 'हमारे बारे में',
      'How to Use': 'कैसे उपयोग करें',
      'Change to Persian': 'हिंदी में बदलें',
      'scan': 'स्कैन करें'
    },

    aboutus: {
      'Our Story': 'हमारी कहानी',
      'Our Team': 'हमारी टीम',
      'Nikhil Katkar': 'निखिल काटकर',
      'Developer': 'डेवलपर',
      'Aditya Jadhav': 'आदित्य जाधव',
      'Gunjan Wadke': 'गुंजन वडके',
      'Guide Teacher': 'मार्गदर्शक शिक्षक',
      'Hrigved Godkar': 'ह्रुग्वेद गोडकर'
    },

    gallaryinfo: {
      'You should fill all fields!': 'आपको सभी फ़ील्ड भरने होंगे!',
      'Space / Gallary name': 'स्थान/गैलरी का नाम',
      'username': 'उपयोगकर्ता नाम',
      'email': 'ईमेल',
      'password': 'पासवर्ड',
      'signup': 'साइन अप करें',
      'Already have an account?': 'पहले से एक खाता है?',
      'Click here to login': 'लॉगिन करने के लिए यहां क्लिक करें',
      'Your password must contain at least 1 digit': 'आपके पासवर्ड में कम से कम 1 अंक होना चाहिए',
      'additional info': 'अतिरिक्त जानकारी',
      'add image': 'चित्र जोड़ें',
      'description': 'विवरण',
      'address': 'पता',
      'phone/contact': 'फ़ोन/संपर्क',
      'next': 'आगे',
      'You should fill name!': 'आपको नाम भरना होगा!',
      'You should fill password!': 'आपको पासवर्ड भरना होगा!',
      'change or set profile image': 'प्रोफ़ाइल चित्र बदलें या सेट करें',
      'done': 'पूरा',
      'remove': 'हटाएं'
    },

    login: {
      'Password is not correct!': 'पासवर्ड सही नहीं है!',
      'There is no gallary with this username!': 'इस उपयोगकर्ता नाम के साथ कोई गैलरी नहीं है!',
      'username': 'उपयोगकर्ता नाम',
      'forgot password?': 'पासवर्ड भूल गए?',
      'password': 'पासवर्ड',
      'login': 'लॉगिन करें',
      "don't have an account?": 'कोई खाता नहीं है?',
      'click here to signup': 'साइन अप करने के लिए यहां क्लिक करें'
    },

    dashboard: {
      'add new item': 'नया आइटम जोड़ें',
      'edit information': 'जानकारी संपादित करें',
      'library': 'पुस्तकालय',
      'logout': 'लॉगआउट'
    },

    editinfo: {
      'Password is not correct!': 'पासवर्ड सही नहीं है!',
      'There is no gallary with this username!': 'इस उपयोगकर्ता नाम के साथ कोई गैलरी नहीं है!',
      'username': 'उपयोगकर्ता नाम',
      'forgot password?': 'पासवर्ड भूल गए?',
      'password': 'पासवर्ड',
      'login': 'लॉगिन करें',
      "don't have an account?": 'कोई खाता नहीं है?',
      'click here to signup': 'साइन अप करने के लिए यहां क्लिक करें',
      'remove': 'हटाएं'
    },

    iteminfo: {
      'description': 'विवरण',
      'play main audio': 'मुख्य ऑडियो चलाएं',
      'view space / gallary info': 'स्थान/गैलरी की जानकारी देखें',
      'Loading...': 'लोड हो रहा है...',
      'stop playing': 'चलाना बंद करें',
      'there is no item': 'कोई आइटम नहीं है',
      'in the library right now!': 'अभी पुस्तकालय में!'
    },

    additem: {
      'You should fill title!': 'आपको शीर्षक भरना होगा!',
      'You should choose a target image!': 'आपको एक लक्षित चित्र चुनना होगा!',
      'Title': 'शीर्षक',
      'add main audio': 'मुख्य ऑडियो जोड़ें',
      'add augmented image or video': 'विस्तारित छवि या वीडियो जोड़ें',
      'add target image': 'लक्षित छवि जोड़ें',
      'Description': 'विवरण',
      'add extra video': 'अतिरिक्त वीडियो जोड़ें',
      'Done': 'पूरा',
      'remove': 'हटाएं'
    }
  },
  // add other language to the object
};